<template>
  <div>
    <button class="mobile-menu-toggle" @click="toggleMobileMenu">
      <font-awesome-icon :icon="isMobileMenuOpen ? 'times' : 'bars'" class="fixed-icon-size" />
    </button>
    <div :class="['menu-container', {
      'dark-mode': isDarkMode,
      'collapsed': isCollapsed && !isMobileMenuOpen,
      'mobile-open': isMobileMenuOpen
    }]" @mouseleave="handleMouseLeave" ref="menuContainer" tabindex="0" @blur="handleMenuBlur">
      <div class="logo-section">
        <div class="logo-wrapper">
          <img :src="logoSrc" alt="Logo" class="logo" :class="{ 'logo-collapsed': isCollapsed }"
            @click="toggleCollapse">
        </div>
      </div>
      <div class="menu-section">
        <ul class="menu-list">
          <li v-for="menuItem in visibleMenuItems" :key="menuItem.title" class="menu-item" @mouseover="handleMouseOver">
            <div>
              <font-awesome-icon :icon="menuItem.icon" class="fixed-icon-size" />
              <span v-if="!isCollapsed" class="menu-item-text">{{ menuItem.title }}</span>
            </div>
            <ul class="sub-menu-list">
              <li v-for="subMenuItem in getFilteredSubMenu(menuItem)" :key="subMenuItem.title" class="sub-menu-item"
                @click="navigateTo(subMenuItem.route)">
                <font-awesome-icon :icon="subMenuItem.icon" class="fixed-icon-size" />
                <span v-if="!isCollapsed" class="submenu-item-text">{{ subMenuItem.title }}</span>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="user-section" @mouseover="handleMouseOver">
        <div class="user-text">
          <img :src="require('../assets/layout/user.webp')" alt="User Photo" class="user-photo">
          <span class="user-name" v-if="!isCollapsed" :title="userName">{{ userName.length > 20 ? userName.substring(0,
            20) + '...' : userName }}</span>
        </div>
        <div class="user-buttons">
          <button @click="CerrarLogin" class="logout-button">
            <span class="user-name" v-if="!isCollapsed">Cerrar Sesion</span>
            <font-awesome-icon icon="sign-out-alt" class="fixed-icon-size" />
          </button>

          <div class="switchdiv">
            <span class="user-name" v-if="!isCollapsed"> Dark Mode </span>
            <label class="switch">
              <input type="checkbox" @change="toggleDarkMode" :checked="isDarkMode">
              <span class="slider round"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="menu-overlay" v-if="isMobileMenuOpen" @click="closeMobileMenu"></div>

  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { faTasks, faClipboardList, faUserCheck, faUsers, faUserPlus, faFileInvoiceDollar, faStore, faStoreAlt, faSun, faMoon, faSignOutAlt, faAngleRight, faAngleLeft, faRoute, faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
// import axios from 'axios';

library.add(faTasks, faClipboardList, faUserCheck, faUsers, faUserPlus, faFileInvoiceDollar, faStore, faStoreAlt, faSun, faMoon, faSignOutAlt, faAngleRight, faAngleLeft, faRoute, faBars, faTimes);

export default {
  name: 'MenuComponent',
  components: {
    FontAwesomeIcon

  },
  props: {
    userData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isCollapsed: false,
      isMobileMenuOpen: false,
      isHovering: false,
      isDarkMode: false,
      menuItems: [],
      clickHandlerActive: false,
      clickTimeout: null,
      rh: '',
      meli: 0,  // Inicializar meli en 0 por defecto
      tienda: '',
      asigEmpId: []
    };
  },
  computed: {
    userName() {
      return this.userData && this.userData.data ? this.userData.data.nombre : '';
    },
    logoSrc() {
      if (this.isCollapsed) {
        return require('../assets/layout/logo-collapsed.webp');
      } else {
        return this.isDarkMode ? require('../assets/layout/betaD.webp') : require('../assets/layout/betaL.webp');
      }
    },
    visibleMenuItems() {
      return this.menuItems.filter(item => {
        // Si el elemento es "Catalogo", solo mostrarlo si el usuario es RH
        if (item.title === 'Catalogo') {
          return this.rh === 'RH';
        }

        return true;
      });
    }
  },
  methods: {
    handleResize() {
      // If screen size changes from mobile to desktop, restore default state
      if (window.innerWidth > 768 && this.isMobileMenuOpen) {
        this.isMobileMenuOpen = false;
        document.removeEventListener('click', this.handleOutsideClick);
      }
    },
    toggleDarkMode() {
      this.isDarkMode = !this.isDarkMode;
      sessionStorage.setItem('darkMode', this.isDarkMode);
      if (this.isDarkMode) {
        document.body.classList.add('dark');
      } else {
        document.body.classList.remove('dark');
      }
    },
    toggleCollapse() {
      // Don't collapse when mobile menu is open
      if (!this.isMobileMenuOpen) {
        this.isCollapsed = !this.isCollapsed;
      }
    },
    CerrarLogin() {
      this.$emit('logout');
    },
    navigateTo(routeName) {
      this.$router.push({ name: routeName });
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;

      if (this.isMobileMenuOpen) {
        // When opening the menu, focus on it and add document click listener
        // but only after a short delay to prevent immediate triggering
        this.$nextTick(() => {
          this.$refs.menuContainer.focus();

          // Clear any existing timeout and handler
          if (this.clickTimeout) {
            clearTimeout(this.clickTimeout);
          }

          if (this.clickHandlerActive) {
            document.removeEventListener('click', this.handleOutsideClick);
            this.clickHandlerActive = false;
          }

          // Add the click handler after a small delay
          this.clickTimeout = setTimeout(() => {
            document.addEventListener('click', this.handleOutsideClick);
            this.clickHandlerActive = true;
          }, 300); // 300ms delay should be enough to avoid accidental clicks
        });
      } else {
        // When closing, remove listener safely
        this.cleanupClickHandler();
      }

      // Save menu state for mobile
      if (window.innerWidth <= 768) {
        sessionStorage.setItem('mobileMenuOpen', this.isMobileMenuOpen);
      }
    },

    cleanupClickHandler() {
      // Safely clean up click handler
      if (this.clickTimeout) {
        clearTimeout(this.clickTimeout);
        this.clickTimeout = null;
      }

      if (this.clickHandlerActive) {
        document.removeEventListener('click', this.handleOutsideClick);
        this.clickHandlerActive = false;
      }
    },

    closeMobileMenu() {
      if (this.isMobileMenuOpen) {
        this.isMobileMenuOpen = false;
        this.cleanupClickHandler();

        // Update stored state
        if (window.innerWidth <= 768) {
          sessionStorage.setItem('mobileMenuOpen', false);
        }
      }
    },

    handleOutsideClick(event) {
      // Prevent multiple rapid invocations by using a flag
      if (!this.clickHandlerActive) return;

      const menuContainer = this.$refs.menuContainer;
      const menuToggle = document.querySelector('.mobile-menu-toggle');

      // Check if we have proper references and if the click is outside
      if (menuContainer &&
        !menuContainer.contains(event.target) &&
        menuToggle &&
        !menuToggle.contains(event.target)) {

        // Temporarily disable the handler to prevent multiple executions
        this.clickHandlerActive = false;

        // Close the menu
        this.closeMobileMenu();
      }
    },

    handleMenuBlur(event) {
      // Only handle blur in mobile view
      if (window.innerWidth <= 768) {
        // Check if focus is moving to an element inside the menu
        if (!this.$refs.menuContainer.contains(event.relatedTarget)) {
          // Small delay to allow clicking on menu items
          setTimeout(() => {
            this.closeMobileMenu();
          }, 100);
        }
      }
    },
    handleMouseOver() {
      if (this.isCollapsed && !this.isHovering && !this.isMobileMenuOpen) {
        this.isHovering = true;
        this.isCollapsed = false;
      }
    },
    handleMouseLeave() {
      if (this.isHovering && !this.isMobileMenuOpen) {
        this.isHovering = false;
        this.isCollapsed = true;
      }
    },
    getFilteredSubMenu(menuItem) {
      // Si es el menú de Control, filtrar la opción "Rutas Meli" según el valor de meli
      if (menuItem.title === 'Control') {
        return menuItem.subMenu.filter(subItem => {
          // Solo mostrar "Rutas Meli" si meli es 1
          if (subItem.title === 'Rutas Meli') {
            return this.meli === 1;
          }
          // Mostrar los demás elementos del submenú
          return true;
        });
      }

      // Si es el menú de Recursos Humanos, filtrar según el rol RH
      if (menuItem.title === 'Recursos Humanos') {
        return menuItem.subMenu.filter(subItem => {
          // Solo mostrar "Registrar Usuario" si el usuario es RH
          if (subItem.title === 'Registrar Usuario') {
            return this.rh === 'RH';
          }
          // Mostrar los demás elementos del submenú
          return true;
        });
      }

      // Para otros menús, devolver todos los submenús
      return menuItem.subMenu;
    },

    async fetchMenuItems() {
      this.menuItems = [
        {
          title: 'Control',
          icon: 'tasks',
          subMenu: [
            { title: 'Rutas', route: 'ControlCasaLey', icon: 'route' },
            {
              title: 'Rutas Meli',
              route: 'ControlRutasMeli',
              icon: 'route',
              requiresMeli: true  // Añadir propiedad para documentar que requiere meli=1
            },
            { title: 'Asistencia', route: 'ControlAsistencia', icon: 'user-check' },
            { title: 'Asignaciones', route: 'ControlAsignaciones', icon: 'tasks' }
          ]
        },
        {
          title: 'Recursos Humanos',
          icon: 'users',
          subMenu: [
            {
              title: 'Registrar Usuario',
              route: 'ControlAltaEmpleados',
              icon: 'user-plus',
              // Agregamos un atributo para identificar elementos que requieren permisos específicos
              requiresRole: 'RH'
            },
            { title: 'Generar CFDI Ingreso', route: 'CfdiIngreso', icon: 'file-invoice-dollar' }
          ]
        },
        {
          title: 'Catalogo',
          icon: 'store',
          subMenu: [
            { title: 'Tiendas', route: 'catalogos', icon: 'store-alt' },
            { title: 'Vehiculos', route: 'catalogos_Flota', icon: 'store-alt' },
          ]
        }
      ];




    }
  },
  async created() {
    // Cargar el puesto del usuario
    this.rh = localStorage.getItem('puesto') || '';
    this.tienda = localStorage.getItem('tienda') || '';

    try {
      // Importar el servicio de asignaciones de forma dinámica para evitar errores
      const AsignacionTiendaServicio = (await import('../service/AsignacionTiendaServicio')).default;
      const asignacionTiendaServicio = new AsignacionTiendaServicio();

      // Obtener datos de asignación
      const usuario = localStorage.getItem('usuario') || '';
      if (usuario) {
        const response = await asignacionTiendaServicio.getEmpId(usuario);
        this.asigEmpId = response.data || [];

        // Verificar si el usuario tiene asignadas tiendas de Meli
        for (let i = 0; i < this.asigEmpId.length; i++) {
          const tiendaMeli = this.asigEmpId[i].nomTiendaMeli;
          if (
            tiendaMeli === 'SMX5' ||
            tiendaMeli === 'SMX4' ||
            tiendaMeli === 'SCT1' ||
            tiendaMeli === 'SMD1' ||
            tiendaMeli === 'SMX6' ||
            tiendaMeli === 'SMX3' ||
            tiendaMeli === 'SMX2'
          ) {
            this.meli = 1;
            // Si el usuario es de RH, no mostrar opciones de Meli
            if (this.tienda === 'RH') {
              this.meli = 0;
            }
            break; // Terminar el ciclo una vez que encontramos una tienda Meli
          }
        }
      }
    } catch (error) {

    }

    // Cargar los ítems del menú después de establecer todos los permisos
    this.fetchMenuItems();

    // Dark mode handling
    const savedDarkMode = sessionStorage.getItem('darkMode');
    if (savedDarkMode) {
      this.isDarkMode = savedDarkMode === 'true';
      if (this.isDarkMode) {
        document.body.classList.add('dark');
      } else {
        document.body.classList.remove('dark');
      }
    }

    // Check if we should show mobile menu
    if (window.innerWidth <= 768) {
      // On first login, show menu by default
      const mobileMenuState = sessionStorage.getItem('mobileMenuOpen');

      // If first time after login or explicitly set to open
      if (mobileMenuState === null || mobileMenuState === 'true') {
        this.isMobileMenuOpen = true;

        // Add click listener with delay to prevent immediate triggering
        this.$nextTick(() => {
          if (this.$refs.menuContainer) {
            this.$refs.menuContainer.focus();
          }

          setTimeout(() => {
            document.addEventListener('click', this.handleOutsideClick);
            this.clickHandlerActive = true;
          }, 300);
        });
      }
    }

    // Listen for resize events to adjust menu behavior
    window.addEventListener('resize', this.handleResize);
  },

  beforeUnmount() {
    // Clean up event listeners
    this.cleanupClickHandler();
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>

<style scoped>
.menu-container {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  display: grid;
  grid-template-rows: auto 1fr auto;
  grid-template-areas:
    "logo"
    "menu"
    "user";
  background-color: var(--background-color);
  height: 100%;
  width: 250px;
  color: var(--text-color);
  transition: width 0.3s, padding 0.3s;
  -webkit-transition: width 0.3s, padding 0.3s;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 100;
  white-space: nowrap;
  padding: 10px;
  overflow: hidden;
  font-size: 0.95rem;
}

.logo-section {
  grid-area: logo;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
  /* Fixed height for the logo section */
  width: 100%;
  padding: 0;
  margin: 0;
  overflow: hidden;
}

.logo-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
}

.logo {
  max-width: 80%;
  max-height: 160px;
  object-fit: contain;
  transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
}

.logo-collapsed {
  max-width: 80%;
  max-height: 150px;
  object-fit: contain;
}

.menu-section {
  grid-area: menu;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 10px 0;
  width: 100%;
  justify-content: flex-start;
  /* Cambiar de center a flex-start para que comience desde arriba */
  flex: 1;
  /* Asegurar que tome el espacio disponible */
}

.user-section {
  grid-area: user;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 20px 0;
  align-items: center;
}

.collapsed {
  width: 70px;
}

.menu-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;

  width: 100%;
}

.menu-item {
  cursor: pointer;
  font-weight: bold;
  color: inherit;
  padding: 10px 15px;
  border-radius: 8px;
  transition: background-color 0.3s, color 0.3s;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  width: 100%;
}

.menu-item>div {
  cursor: default;
  position: relative;
  z-index: 1;
  max-height: 31px;
  min-height: 31px;
  display: flex;
  align-items: center;
}

.menu-item span,
.sub-menu-item span {
  margin-left: 10px;
  overflow: hidden;
  display: inline-block;
}

.dark-mode .menu-item:hover {
  background-color: #444444;
}

.menu-item:hover {
  background-color: #f9f7f7;
}

.sub-menu-list {
  list-style: none;
  padding: 0;
  margin: 0;
  margin-top: 10px;
}

.sub-menu-item {
  cursor: pointer;
  font-weight: normal;
  color: inherit;
  padding: 5px 0;
  transition: color 0.3s;
  display: flex;
  align-items: center;
  max-height: 31px;
  min-height: 31px;
}

.sub-menu-item:hover {
  color: var(--primary-color);
}

.user-text {
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 12px;
  background-color: var(--card-background-color);
  border-radius: 8px;
  width: 100%;
  padding: 10px;
  gap: 10px;
  justify-content: center;
  opacity: 1;
  transition: opacity 0.3s ease-in-out;
}

.user-name {
  transition: opacity 0.3s;
}

.collapsed .user-name {
  opacity: 0;
  width: 0;
  display: none;
}

.collapsed .user-text {
  justify-content: center;
  padding: 10px 5px;
}

.user-photo {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.user-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.logout-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background-color: #d1334c;
  color: white;
  padding: 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.logout-button:hover {
  background-color: #d9344d;
}

.switchdiv {
  display: flex;
  align-items: center;
  gap: 13px;
  justify-content: center;
}

.switch {
  position: relative;
  display: inline-block;
  width: 34px;
  height: 20px;
  flex-shrink: 0;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 34px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 12px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked+.slider {
  background-color: #2196F3;
}

input:checked+.slider:before {
  transform: translateX(14px);
}

.fixed-icon-size {
  width: 1.2em;
  height: 1.2em;
  vertical-align: 0em;
}

.mobile-menu-toggle {
  display: none;
  position: fixed;
  top: 0px;
  left: 0px;
  padding: 10px;
  background: none;
  border: none;
  font-size: 1.5rem;
  z-index: 1000;
  color: var(--dark-icon-color);
  cursor: pointer;
}

@media (max-width: 768px) {
  .mobile-menu-toggle {
    display: block;
  }

  .menu-container {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    /* Usar 100vh en lugar de 100% */
    width: 250px;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    grid-template-rows: auto minmax(0, 1fr) auto;
    /* Usar minmax para permitir que menu-section se expanda */
    overflow-y: auto;
    padding-bottom: 20px;
    /* Agregar padding inferior para asegurar visibilidad */
  }

  .menu-container.mobile-open {
    transform: translateX(0);
    width: 250px;
    max-height: 100vh;
    overflow-y: auto;
    display: grid;
    /* Asegurar que se mantiene la estructura grid */
  }

  .menu-section {
    max-height: none;
    /* Eliminar max-height fija */
    overflow-y: visible;
    /* Cambiar a visible */
    min-height: 0;
    /* Permitir que se encoja si es necesario */
    flex-grow: 1;
    /* Permitir que crezca */
  }

  .logo-section {
    height: 60px;
    flex-shrink: 0;
    /* Evitar que se encoja */
  }

  .user-section {
    flex-shrink: 0;
    /* Evitar que la sección de usuario se encoja */
    padding-bottom: 10px;
    /* Asegurar espacio inferior */
  }

  /* Asegurar que los elementos del menú y submenú sean completamente visibles */
  .menu-list {
    width: 100%;
    margin-bottom: 10px;
    /* Añadir espacio después de la lista */
  }

  .sub-menu-list {
    width: 100%;
    padding-left: 15px;
    /* Indentar submenús */
  }
}

/* Removing unused styles and keeping only the essential ones */

.menu-container:focus {
  outline: none;
  /* Remove focus outline for better appearance */
}

.menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99;
  /* Below menu but above other content */
  display: none;
}

@media (max-width: 768px) {
  /* ...existing mobile styles... */

  .menu-overlay {
    display: block;
    /* Show overlay on mobile */
  }
}
</style>
